module.exports = __webpack_public_path__ + "img/midjourney-demo.a484873f.webp";